import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepSupportingDocuments.sectionTitle',
    defaultMessage: 'Section 9 - Supporting Documentation',
  },
  provideAll: {
    id: 'fastCover.stepSupportingDocuments.provideAll',
    defaultMessage: 'Provide all that are relevant to your claim',
  },
  yes: {
    id: 'fastCover.stepSupportingDocuments.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepSupportingDocuments.no',
    defaultMessage: 'No',
  },
  doYouHaveSupportingDocuments: {
    id: 'fastCover.stepSupportingDocuments.doYouHaveSupportingDocuments',
    defaultMessage:
      'Do you have supporting documents you would like to attach to this claim?',
  },
  attachSupportingDocuments: {
    id: 'fastCover.stepSupportingDocuments.attachSupportingDocuments',
    defaultMessage: 'Attach supporting documents',
  },
  upload: {
    id: 'fastCover.stepSupportingDocuments.upload',
    defaultMessage: 'Upload',
  },
  orDragFilesHere: {
    id: 'fastCover.stepSupportingDocuments.orDragFilesHere',
    defaultMessage: 'or drag files here',
  },
  weCanAssess: {
    id: 'fastCover.stepSupportingDocuments.weCanAssess',
    defaultMessage: 'We can assess claims quicker if we receive all the required documentation. Please review the list below and provide the documents that are relevant to your claim.',
  },
  DocDocument: {
    id: 'fastCover.stepSupportingDocuments.DocDocument',
    defaultMessage: 'Document',
  },
  DocRequired: {
    id: 'fastCover.stepSupportingDocuments.DocRequired',
    defaultMessage: 'Required',
  },
  DocUploaded: {
    id: 'fastCover.stepSupportingDocuments.DocUploaded',
    defaultMessage: 'Uploaded File(s)',
  },
  DocActions: {
    id: 'fastCover.stepSupportingDocuments.DocActions',
    defaultMessage: 'Actions',
  },
  UploadAny: {
    id: 'fastCover.stepSupportingDocuments.UploadAny',
    defaultMessage: 'Upload any additional documents that may help in resolving your claim faster',
  },
  SupportingDocs: {
    id: 'fastCover.stepSupportingDocuments.SupportingDocs',
    defaultMessage: 'Supporting Documents',
  },
  warningMissingRequiredDocument: {
    id: 'fastCover.stepSupportingDocuments.warningMissingRequiredDocument',
    defaultMessage: 'Warning – Missing Required Documents!',
  },
  warningMissingRequiredDocumentText1: {
    id: 'fastCover.stepSupportingDocuments.warningMissingRequiredDocumentText1',
    defaultMessage: 'You have not attached Required Documents that are mandatory for processing of this claim. You may still proceed to next steps of this claim, however please be sure to return to this page and attach all Required Documents. You can save this claim as a draft and return anytime within 30 days of commencement to attach all Required Documents.',
  },
  wouldYouLikeToProceedToNextSteps: {
    id: 'fastCover.stepSupportingDocuments.wouldYouLikeToProceedToNextSteps',
    defaultMessage: 'Would you like to proceed to next steps',
  },
  InitialDocumentReview: {
    id: 'fastCover.stepSupportingDocuments.InitialDocumentReview',
    defaultMessage: 'Validation Message',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/messages.js